module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av239-6f27870bc959c6bd2d0d14138a718517.jpg";